import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("dot-pagination", () => {
    it("should emit uxPaginationChange event and match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-dot-pagination total="10" max-dots="5" page="1"></ux-dot-pagination>`
        );
        const paginationChange = await page.spyOnEvent("uxPaginationChange");
        const el = await page.find("ux-dot-pagination");
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");

        const dots = await page.findAll(".ux-dot-pagination__item");
        await dots[3].click();

        expect(paginationChange).toHaveReceivedEventDetail({ page: 4 });
        await page.waitForChanges();
        expect(dots[3]).toHaveClass("ux-dot-pagination__item--active");

        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `<ux-dot-pagination total="10" max-dots="5" page="5"></ux-dot-pagination>`
        );
    });
});
